<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>配套设置</a-breadcrumb-item>
    <a-breadcrumb-item>版本更新策略</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <div style="flex: 1;"></div>
    <a-button type="primary" @click="handleAdd()"><plus-outlined />新增策略</a-button>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :loading="isLoading"
    :pagination="pagination"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record, index }">
      <!-- 是否强制 -->
      <template v-if="column.key === 'status'">
        {{ record.status === 1 ? '是' : '否' }}
      </template>
      <!-- 目标平台 -->
      <template v-if="column.key === 'platform'">
        {{ (record.platform || []).join('、') }}
      </template>
      <!-- 操作 -->
      <template v-if="column.key === 'operation'">
      <!-- 编辑 -->
        <a-button
          type="link"
          @click="handleAdd(record)"
        >
          编辑
        </a-button>
        <!-- 删除 -->
        <a-popconfirm
          title="确定要删除吗？"
          @confirm="handleDelete(record)"
        >
          <a-button type="link">删除</a-button>
        </a-popconfirm>
        <!-- 上移：第一组禁用 -->
        <a-button
          type="link"
          @click="handleSort(record, 'up')"
          :disabled="index === 0"
        >
          上移
        </a-button>
        <!-- 下移：最后一组禁用 -->
        <a-button
          type="link"
          @click="handleSort(record, 'down')"
          :disabled="index === dataSource.length - 1"
        >
          下移
        </a-button>
      </template>
    </template>
  </a-table>
  <!-- 新增、编辑抽屉 -->
  <Add ref="RefAdd" @success="getList"></Add>
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { FrontSource } from '@/utils/constantList'
import { message } from 'ant-design-vue'
import Add from './components-versionupdate/Add'
import { versionList, versionSort, versionDelete } from '@/api/admin'

// 新增、编辑组件实例
let RefAdd = ref(null)
// source类型
const source = FrontSource.banner
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10
})
// 列数据源（付费转化率、权重本期不做）
let columns = ref([
  {
    title: '优先级',
    dataIndex: 'sort',
    key: 'sort'
  },
  {
    title: '策略名称',
    dataIndex: 'name',
    key: 'name',
    width: 150
  },
  {
    title: '目标平台',
    dataIndex: 'platform',
    key: 'platform',
    width: 150
  },
  {
    title: '目标版本',
    dataIndex: 'version',
    key: 'version',
    width: 150
  },
  {
    title: '是否强制',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 钩子函数
onBeforeMount(() => {
  // 获取配置列表
  getList()
})

// 获取配置列表
function getList () {
  isLoading.value = true
  const params = {
    page: pagination.current,
    page_size: pagination.pageSize
  }
  versionList(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data.data
    } else {
      message.error(res.message || msg)
    }
  })
}

// 新增、编辑banner
function handleAdd (record) {
  RefAdd.value.showDrawer(record || {})
}

// 删除banner 
function handleDelete (record) {
  isLoading.value = true
  const params = {
    id: record.id
  }
  versionDelete(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      message.success('删除成功')
      // 更新列表
      getList()
    } else {
      message.error(res.message || msg)
    }
  })
}

// 排序banner
function handleSort (record, type) {
  isLoading.value = true
  const params = {
    id: record.id,
    type
  }
  versionSort(params).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      // 更新列表
      getList()
    } else {
      message.error(res.message || msg)
    }
  })
}

// 表格change
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}
</script>

<style lang="less" scoped>
.tool-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 20px;
}
.cover-img {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.ant-btn-link {
  padding: 0;
  margin-left: 8px;
}
</style>